@if (job_candidate_id) {
  <app-meeting-record
    [meetingableType]="meetingableType"
    [meetingableId]="meetingableId"
    [meetingRecordId]="meetingRecordId"
    [jobVacancyCandidateId]="job_candidate_id"
    [onSaveRoute]="
      '/employees/rrhh/job-vacancies/' + job_vacancy_id + '/candidates/' + job_candidate_id + '/meeting-records/:meeting_record_id'
    "
    [onBackRoute]="candidateDetailRouterLink()"
  >
  </app-meeting-record>
}
